import { Map, fromJS } from 'immutable'
import { combineReducers } from 'redux-immutable'
import { handleActions, combineActions } from 'redux-actions'

import * as actions from './actions'

const targetsById = handleActions(
  {
    [actions.fetchTargetsSuccess]: (state, action) =>
      action.payload.reduce((acc, target) => acc.set(target.id, target), Map()),
    [actions.updateTargetSuccess]: (state, action) => state.setIn(['targetsById', action.payload.id], fromJS(action.payload))
  },
  Map(),
)

const lastCreatedTargetId = handleActions(
  {
    [actions.createTargetSuccess]: (state, action) => action.payload.id
  },
  -1
)

const lastUpdatedTargetId = handleActions(
  {
    [actions.updateTargetSuccess]: (state, action) => action.payload.id
  },
  -1
)

const status = handleActions(
  {
    [combineActions(
      actions.fetchTargetsPending,
      actions.fetchTargetsSuccess,
      actions.fetchTargetsFailed,
      actions.updateTargetPending,
      actions.updateTargetSuccess,
      actions.updateTargetFailed,
      actions.createTargetPending,
      actions.createTargetSuccess,
      actions.createTargetFailed,
    )]: (state, action) => {
      return action.type
    },
  },
  false,
)

export default combineReducers({
  targetsById,
  status,
  lastCreatedTargetId,
  lastUpdatedTargetId
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/targeting/reducer.js